export interface IDokOption {
  value: number;
  label: string;
}

export const dokOptions: Array<IDokOption> = [
  { value: 1, label: "1 - Recall" },
  { value: 2, label: "2 - Skill/Concept" },
  { value: 3, label: "3 - Strategic Thinking" },
  { value: 4, label: "4 - Extended Thinking" },
];
